<template>
  <li class="site-map__node">
    <a
      v-if="isExternal"
      class="site-map__link"
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
    >{{ item.label }}</a>
    <router-link
      v-else-if="href"
      class="site-map__link"
      :to="href"
    >{{ item.label }}</router-link>
    <span v-else class="site-map__label">{{ item.label }}</span>
    <ul v-if="hasChildren" class="site-map__tree site-map__tree--nested" role="list">
      <sitemap-node
        v-for="(child, index) in children"
        :key="child.id || child.to || index"
        :item="child"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'SitemapNode',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    children() {
      return (this.item && this.item.children) || []
    },
    hasChildren() {
      return this.children.length > 0
    },
    href() {
      return this.item && this.item.to ? String(this.item.to).trim() : ''
    },
    isExternal() {
      return /^https?:\/\//i.test(this.href)
    },
  },
}
</script>
